import { EventSchema } from '../../interfaces/EventInterfaces'
import { EVENT_NAME as EN } from '../../constants/EventName'
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey'
import { CommonEventProperties } from '../../utils/CommonParams'

export const CategoryClickedEventSchema = (): EventSchema => {
  return {
    eventName: EN.CATEGORY_CLICKED,
    params: {
      ...CommonEventProperties,
      BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
      EVENT_CATEGORY: EPK.EVENT_CATEGORY,
      CATEGORY_NAME: EPK.CATEGORY_NAME,
      CATEGORY_LEVEL: EPK.CATEGORY_LEVEL,
      STORE_ID_SAP: EPK.STORE_ID_SAP,
      STORE_ID_DBP: EPK.STORE_ID_DBP,
    },
  }
}
